export const Message = {
    otherError: "システムエラー。({0})",
    resultEdit: "更新しました。",
    resultDelete: "削除しました。"
}